/**
 * @author Hiroki Moto
 * @description Edit dropdowns
 * Demo: https://cl.ly/859e16f5c735
 * Example Usage: <EditDropdown options={['Edit', 'Assign']} onChange={this.handleChange} />
 * Example Returns to onChange: 'edit', 'assign'
 */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import toLower from 'ramda/src/toLower';
import cx from 'classnames';
import Dropdown from '@components/@core/Dropdown';

function EditDropdown(props) {
    const {
        className,
        caret = 'dots-without-title',
        defaultIndexes = [],
        options = ['Assign', 'Edit', 'Delete'],
        optionsWithRenderIcon,
        disabled = false,
        disabledOptions = [],
        icon = 'fas fa-ellipsis',
        iconColor = '#969faa',
        onChange = () => {},
        dataCy,
        keepOriginalValue = false,
        ...rest
    } = props;

    const data = useMemo(() => {
        if (optionsWithRenderIcon) {
            return optionsWithRenderIcon.map((option, index) => ({
                id: index,
                value: option?.value,
                renderIcon: option?.renderIcon,
            }));
        }
        if (options) {
            return options.map((option, index) => ({ id: index, value: option }));
        }
    }, [options, optionsWithRenderIcon]);

    const handleDropdownChange = (e) => {
        if (keepOriginalValue) {
            onChange(e[0].value);
        } else {
            onChange(toLower(e[0].value));
        }
    };

    return (
        <Dropdown
            {...rest}
            className={cx('edit-dropdown', className)}
            defaultIndexes={defaultIndexes}
            data-cy={dataCy}
            id="dots-menu"
            caret={caret}
            disabled={disabled}
            disabledOptions={disabledOptions}
            iconSize={16}
            icon={icon}
            iconColor={iconColor}
            data={data}
            align="right"
            returnBy="data"
            stopPropagation
            onChange={handleDropdownChange}
        />
    );
}

EditDropdown.propTypes = {
    caret: PropTypes.string,
    defaultIndexes: PropTypes.array,
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    options: PropTypes.array,
    disabled: PropTypes.bool,
    disabledOptions: PropTypes.array,
    onChange: PropTypes.func,
};

export default EditDropdown;
